module.exports = __webpack_public_path__ + "img/ODOMETER.718a1bf4.svg";